import type { GeoCoordinates } from '@repo/domain';
import type { TestId } from '@repo/test-id';
import { type InputSize } from '@repo/ui';
import classNames from 'classnames';
import { tr } from '@repo/locale';

import { AddressAutocompleteField } from '@features/parkingSearch/components/address/AddressAutocompleteField';
import { useAddressSearch } from '@features/parkingSearch/hooks/useAddressSearch';

interface Props {
  value: string;
  onChange: (value: string, coordinates?: GeoCoordinates) => void;
  testId: TestId;
  size?: InputSize;
  compact?: boolean;
  showHeader?: boolean;
}

export default function AddressSelector({ value, onChange, testId, size = 'lg', compact, showHeader }: Props) {
  const {
    predictions,
    showPredictions,
    activeIndex,
    handleInputChange,
    handlePredictionSelect,
    handleInputBlur,
    handleInputFocus,
    handleKeyDown,
  } = useAddressSearch({ value, onChange });

  return (
    <div className="flex flex-col gap-2">
      {showHeader && (
        <p
          className={classNames('text-heading justify-start font-medium', {
            'text-base': compact,
            'text-lg': !compact,
          })}
        >
          {tr('parking_search:desktop_bar.address_label')}
        </p>
      )}
      <AddressAutocompleteField
        value={value}
        onChange={handleInputChange}
        onBlur={handleInputBlur}
        onFocus={handleInputFocus}
        onKeyDown={handleKeyDown}
        predictions={predictions}
        showPredictions={showPredictions}
        activeIndex={activeIndex}
        onPredictionSelect={handlePredictionSelect}
        size={size}
        testId={testId}
      />
    </div>
  );
}
